<template>
  <div class="scroll-menu-container">
    <el-button
      v-if="showButtons"
      icon="el-icon-arrow-left"
      class="scroll-button left"
      @click="scrollLeft"
      :disabled="isLeftDisabled"
    ></el-button>
    <div ref="menuContainer" class="menu-container" >
      <slot></slot>
    </div>
    <el-button
      v-if="showButtons"
      icon="el-icon-arrow-right"
      class="scroll-button right"
      @click="scrollRight"
      :disabled="isRightDisabled"
    ></el-button>
  </div>
</template>

<script>
export default {
  name: 'ScrollMenu',
  data() {
    return {
      isLeftDisabled: true,
      isRightDisabled: false,
      showButtons: false, // 新增
    };
  },
  methods: {
    scrollLeft() {
      const container = this.$refs.menuContainer;
      container.scrollBy({
        left: -200, // 滚动距离
        behavior: 'smooth',
      });
      this.checkScrollPosition();
    },
    scrollRight() {
      const container = this.$refs.menuContainer;
      container.scrollBy({
        left: 200, // 滚动距离
        behavior: 'smooth',
      });
      this.checkScrollPosition();
    },
    checkScrollPosition() {
      const container = this.$refs.menuContainer;
      this.isLeftDisabled = container.scrollLeft === 0;
      this.isRightDisabled =
        container.scrollLeft + container.clientWidth >= container.scrollWidth;
         // 判断是否需要显示按钮
      this.showButtons = container.scrollWidth > container.clientWidth;
    },
  },
  mounted() {
    this.checkScrollPosition();
    window.addEventListener('resize', this.checkScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScrollPosition);
  },
};
</script>

<style lang="scss" scoped>
.scroll-menu-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 40px - 170px - 380px);
  overflow: hidden;
}

.menu-container {
  display: block;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.menu-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.scroll-button {
  color: #fff;
  border: none;
  background-color: transparent;
  padding: 8px;
  cursor: pointer;
}
.scroll-button.is-disabled, .scroll-button.is-disabled:focus, .scroll-button.is-disabled:hover {
    color: #C0C4CC;
    cursor: not-allowed;
    background-image: none;
    border: none;
    background-color: transparent;
}

.scroll-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.left {
  margin-right: 8px;
}

.right {
  margin-left: 8px;
}
</style>